import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMinxin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/grid/todolist-group-title.scss';

Component('tr-grid-todolist-group-title', {
  mixins: [eventListenerMinxin],

  properties: {
    guid: String,
    creationUrl: String,
    editUrl: String,

    editing: {
      type: Boolean,
      default: false,
      observer: 'editingChanged',
    },
  },

  connected() {
    this.titleInput = this.querySelector('.title-input');
    this.originalTitle = this.titleInput.value;
    this.titleShadow = this.querySelector('.title-shadow');

    this.listenTo(this, {
      'tr-menu:opened': () => this.classList.add('show-more-action'),
      'tr-menu:closed': () => this.classList.remove('show-more-action'),
      'tr-menu:selected': this.handleEditMenuItemClick.bind(this),
    });

    this.listenTo(this.titleInput, {
      blur: this.handleTitleInputBlur.bind(this),
      keydown: this.handleTitleInputKeydown.bind(this),
    });

    this.editingChanged(this.editing);
  },

  disconnected() {
    this.stopListening();
  },

  editingChanged(editing) {
    if (editing) {
      this.titleInput.focus();

      const { length: selectionOffset } = this.titleInput.value;
      this.titleInput.setSelectionRange(selectionOffset, selectionOffset);
    }
  },

  handleEditMenuItemClick(event) {
    const { item: menuItem } = event.detail;
    this.editing = menuItem.querySelector('.link-edit-todolist');
  },

  handleTitleInputBlur() {
    if (this.skipTitleInputBlurHandler) {
      this.skipTitleInputBlurHandler = false;
      return;
    }

    this.submitTitleInput();
  },

  handleTitleInputKeydown(event) {
    this.titleShadow.innerHTML = this.titleInput.value;
    if (event.isComposing || event.keyCode === 229) return;

    const isEnter = event.key === 'Enter' || event.keyCode === 13;
    const isEscape = event.key === 'Escape' || event.keyCode === 27;
    const isBackspace = event.key === 'Backspace' || event.keyCode === 8;

    if (isEnter || isEscape || isBackspace) {
      this.skipTitleInputBlurHandler = true;
    }

    if (isEnter) {
      event.preventDefault();
      event.stopPropagation();
      this.submitTitleInput();
    } else if (isEscape) {
      this.titleShadow.innerHTML = this.originalTitle;
      if (this.guid) {
        this.editing = false;
        this.titleInput.value = this.originalTitle;
      } else {
        this.namespacedTrigger('cancelCreate', { bubbles: true });
      }
    } else if (isBackspace && !this.titleInput.value && !this.guid) {
      this.namespacedTrigger('cancelCreate', { bubbles: true });
    }
  },

  submitTitleInput() {
    if (this.guid) {
      this.updateTodolist();
    } else {
      this.createTodolist();
    }
  },

  createTodolist() {
    const { value } = this.titleInput;
    if (!value) {
      this.namespacedTrigger('cancelCreate', { bubbles: true });
      return;
    }

    this.titleInput.disabled = true;

    $.ajax({
      url: this.creationUrl,
      method: 'post',
      data: {
        todolist: { name: value },
        tao_id: this.taoId,
      },
      dataType: 'script',
    });
  },

  updateTodolist() {
    const { value } = this.titleInput;
    if (!value || value === this.originalTitle) {
      this.editing = false;
      this.titleInput.value = this.originalTitle;
      return;
    }

    this.titleInput.disabled = true;

    $.ajax({
      url: this.editUrl,
      method: 'patch',
      data: {
        todolist: { name: value },
      },
      dataType: 'script',
    }).then(() => {
      this.titleInput.disabled = false;
      this.originalTitle = value;
      this.querySelector('.title').textContent = value;
      this.editing = false;
    });
  },
});
